import { Form, FormInstance, Select } from "antd";
import React from "react";
import { useParams } from "react-router-dom";

const { Option } = Select;

interface TypeProps {
  form: FormInstance;
}

const ClientType: React.FC<TypeProps> = ({ form }) => {
  const { id } = useParams();
  const clientType = Form.useWatch("type", form);
  const options = [
    { name: "Screening", value: "screening" },
    { name: "Monitoring", value: "monitoring" },
    { name: "VitAlert", value: "vitalert" },
    { name: "Channel Partner", value: "channel_partner" },
  ];

  return (
    <Form.Item name="type" label="Type">
      <Select placeholder="Select Type" disabled={clientType ? true : false}>
        {options.map((type) => (
          <Option key={type.value} value={type.value}>
            {type.name}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default ClientType;
